import { Commit } from "vuex"
import { ISessionState } from "@/interfaces"

/**
 * Returns a fresh default state for the session Vuex module.
 * Using a factory avoids shared mutable defaults between module instances.
 * @returns ISessionState
 */
const getDefaultState = (): ISessionState => {
	return {
		id: null,
	}
}

export default {
	state: getDefaultState(),
	getters: {
		/**
		 * Read-only getter returning the current session id.
		 */
		sessionId(state: ISessionState): string | null {
			return state.id
		},
	},
	mutations: {
		/**
		 * Mutations for updating the session id.
		 */
		setId(state: ISessionState, id: string) {
			state.id = id
		},
		unsetId(state: ISessionState) {
			state.id = null
		},
		/**
		 * Resets session module state to defaults.
		 */
		resetState(state: ISessionState) {
			Object.assign(state, getDefaultState())
		},
	},
	actions: {
		setId({ commit }: { commit: Commit }, id: string) {
			commit("setId", id)
		},
		unsetId({ commit }: { commit: Commit }) {
			commit("unsetId")
		},
		resetSession({ commit }: { commit: Commit }) {
			commit("resetState")
		},
	},
}
